import { Divider, Typography } from 'antd';
import React, { useContext } from 'react';
import { MenuItem } from '~/types/Menu';
import { formatCurrency } from '~/utils/currency';
import { CartItem } from '~/types/Cart';
import './style.css';
import useOpenCartPanel from '../../../CartPanel/hooks/useOpenCartPanel';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { CartPanelMode } from '../../../CartPanel/constants';

const { Title, Text } = Typography;

const CartItemRow = ({
  index,
  menuItem,
  cartItem,
  disabled,
}: {
  index: number;
  menuItem: MenuItem;
  cartItem: CartItem;
  disabled: boolean;
}) => {
  const { editCart } = useContext(CartActionContext);
  const openCartPanel = useOpenCartPanel();

  const onClick = () => {
    if (disabled) return;
    openCartPanel({
      mode: CartPanelMode.Edit,
      item: menuItem,
      initialValues: cartItem,
      index,
      onSubmit: (values: CartItem) => {
        editCart(values, index);
      },
    });
  };

  let addOnMap: Record<string, any> = {};
  if (!cartItem.custom) {
    addOnMap = menuItem.addOns.reduce((acc, cur) => {
      acc[cur.id] = cur;
      return acc;
    }, {} as Record<string, any>);
  }

  return (
    <div className="cart-list-row" key={cartItem.menuId} onClick={onClick}>
      <div className="cart-list-item-row">
        <Title level={5} style={{ marginBottom: 0 }}>
          {`${cartItem.quantity} ${
            cartItem.custom ? cartItem.name : menuItem.name
          }`}
        </Title>
        <Text>
          {formatCurrency(
            cartItem.custom
              ? cartItem.totalPrice ?? 0
              : menuItem.price * cartItem.quantity
          )}
        </Text>
      </div>
      {cartItem.addOns?.map(({ menuId: addOnId, quantity }) => {
        const addOn = addOnMap[addOnId];
        return (
          <div className="cart-list-item-row" key={addOnId}>
            <Text>{`${quantity} ${addOn.name}`}</Text>
            <Text>{formatCurrency(addOn.price * quantity)}</Text>
          </div>
        );
      })}
      {cartItem.notes ? (
        <Text italic style={{ fontSize: 12 }}>
          {cartItem.notes}
        </Text>
      ) : null}
      <Divider style={{ marginTop: 4, marginBottom: 4 }} />
    </div>
  );
};

export default CartItemRow;
